<template>
<div class="" style="">

   <!-- SEZIONE SEARCH -->
   <search :tipo="($route.params.tipo>0)?$route.params.tipo*1:0" :provider="($route.params.provider>0)?$route.params.provider*1:''" :interesse="($route.params.interesse>0)?$route.params.interesse*1:''" :iniziail="$route.params.iniziail" :finisceil="$route.params.finisceil" :citta="$route.params.citta"></search>


   <div class="row pad-in " style="padding:20px 0;background:#E3EDF9;" >
      <div class="col s12 evento-elenco-fad">



        <div v-if="eventi.length<1" class="yo-align-center">La ricerca non ha prodotto alcun risultato.</div>




         <eventofad v-if="tipo==1" v-for="item in eventi" :evento="item" :key="item.id" class="medicina"></eventofad>
         <eventores v-if="tipo==0" v-for="item in eventi" :evento="item" :key="item.id" class="medicina"></eventores>
      </div>
   </div>


   <!-- SEZIONE AREE -->
   <aree></aree>
   
</div>
</template>

<script>
import eventores from '../components/Evento-elenco-res'
import eventofad from '../components/Evento-elenco-fad'
import aree from '../components/Aree'
import search from '../components/Evento-search-form'

export default {
  name: 'home',
  components: {
    eventores
    ,eventofad
    ,aree
    ,search
    
  },
  created () {
    this.$teras.page.title = "BioMedia"
    this.$teras.page.sezione = "EVENTI"
    this.fetchData()
    /*
    this.readyInterval = setInterval(() => { 
           console.log("ENTRO ANCORA")
           console.log(this.eventi.length)
            if(this.eventi.length>0){
              
              clearInterval(this.readyInterval)
              }
          }, 500)
          */
  },
   data(){
      return{
        readyInterval: false
         ,tipo:0
         ,iniziail: ''
         ,finisceil: ''
         ,interesse: ''
         ,provider: ''
         ,citta:''
      }
   },
  watch: {
      '$route': 'fetchData'
   },
   methods: {
      fetchData () {
        console.log("FETCHDATA")
        
         this.finisceil = (this.$route.params.finisceil || ' ')
         this.iniziail = (this.$route.params.iniziail || this.$moment().format('YYYY-MM-DD'))
         this.tipo = this.$route.params.tipo*1
         this.interesse = (this.$route.params.interesse*1  || '')
         this.provider = (this.$route.params.provider*1  || ' ')
         
         if(this.$route.params.citta == ' ')
          this.$route.params.citta = ''
         this.citta = (this.$route.params.citta  || '')

         console.log((this.$route.params.iniziail || this.$moment().format('YYYY-MM-DD')))


      }
   },
   computed: {
      eventi: function () {
         var itemFilter = []
         for (let item of this.$teras._evento){
            //console.log(item.id+'->'+item.interesse.toString())
            //console.log(item.interesse.toString().split(","))
            //if(this.$moment().isBetween(item.iniziail, item.finisceil, null, '[]') && item.tipologiaformazione==1)
            if(
               
               ((this.tipo==0 && item.tipologiaformazione!=1) || (this.tipo==1 && item.tipologiaformazione==1) )
               &&
               (this.iniziail.length<4 || this.$moment(this.iniziail).isBefore(item.iniziail, null, '[]'))
               &&
               (this.finisceil.length<4 || this.$moment(this.finisceil).isAfter(item.finisceil, null, '[]'))
               &&
               (this.provider<1 || item.provider==this.provider)
               &&
               (this.interesse<1 || (item.interesse.length>1 && this.$teras.findinset(this.interesse,item.interesse.split(","))))
               &&
               (this.citta=='' || (item.citta.length>1 && item.citta.toLowerCase().indexOf(this.citta) > -1 ))
               
               

               
            
            )
               itemFilter.push(item) 
            if(item.citta.toLowerCase().indexOf(this.citta) > -1)
              console.log(item.citta+ " = "+this.citta)
         }
         return itemFilter
      }
   }
}
</script>


<style>
.arrow-right {
  width: 0; 
  height: 0; 
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  float:left;
  border-left: 14px solid white;

  margin-top:6px;
}
.catalogo-fad .header{
   background-image:url('../assets/catalogo-fad.png');
}
.fad-evidenza{
   padding-top:10px;
   height:170px;overflow:hidden;
}
.fad-evidenza:first-child{
   padding-top:20px;
   height:180px;overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Evento-search.vue